export default __webpack_public_path__ + "static/media/bg.7742d55f.png";